import SiBackpack from '@/icons/SiBackpack';
import SiBattery from '@/icons/SiBattery';
import SiCoins from '@/icons/SiCoins';
import SiCommand from '@/icons/SiCommand';
import SiGaming from '@/icons/SiGaming';
import SiInformation from '@/icons/SiInformation';
import SiKeyboard2 from '@/icons/SiKeyboard2';
import SiLaptop from '@/icons/SiLaptop';
import SiMicrochip from '@/icons/SiMicrochip';
import SiMonitor from '@/icons/SiMonitor';
import SiMouse from '@/icons/SiMouse';
import SiUsb from '@/icons/SiUsb';
import { ReactNode } from 'react';

const icons: Record<string, ReactNode> = {
  monitors: <SiMonitor />,
  laptops: <SiLaptop />,
  keyboard: <SiKeyboard2 />,
  power: <SiBattery />,
  bag: <SiBackpack />,
  mouse: <SiMouse />,
  connection: <SiUsb />,
  fee: <SiCoins />
};

// This is a slightly odd pattern in that we're using a Proxy to provide
// custom logic on how to handle icons that aren't found in the icons object
// or use a different name. Here we're able to transparently handle the
// different names for the same icon without having to define multiple entries.
export const CategoryIcons = new Proxy(icons, {
  get: function (target, name) {
    if (typeof name === 'symbol') throw new Error('Symbol not supported');
    const icon = target[name];
    // If we have an icon, return it
    if (icon) return icon;

    // Otherwise, try to find an icon that matches the name
    switch (name.toLowerCase()) {
      case 'chip':
        return <SiMicrochip />;
      case 'gaming':
        return <SiGaming />;
      case 'command':
        return <SiCommand />;
      default:
        return <SiInformation />;
    }
  }
});
